import {Component, input, InputSignal} from '@angular/core';
import {IVehicle} from '@service-and-repairs/awpintegrationlib';
import {DatePipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-vehicle-data-overlay',
  templateUrl: 'vehicle-data-overlay.html',
  styleUrls: ['vehicle-data-overlay.scss'],
  imports: [DatePipe, TranslateModule]
})
export class VehicleDataOverlayComponent {
  readonly vehicle: InputSignal<IVehicle> = input<IVehicle>();
  readonly mileage: InputSignal<string> = input<string>();
  readonly locale: InputSignal<string> = input<string>();
}
